import { render, staticRenderFns } from "./DevolucionList.vue?vue&type=template&id=40054120&scoped=true&"
import script from "./DevolucionList.vue?vue&type=script&lang=js&"
export * from "./DevolucionList.vue?vue&type=script&lang=js&"
import style0 from "./DevolucionList.vue?vue&type=style&index=0&id=40054120&scoped=true&lang=css&"
import style1 from "./DevolucionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40054120",
  null
  
)

export default component.exports